<template>
    <div class="ysLogin">
        <div class="outer" v-if="isLogin">
            <div class="img-div-outer">
                <img :src="require('@/assets/logo/outer.png')" alt />
                <div class="inner text-center" :class="setMarginTop?'inner1':''">
                    <el-tabs v-model="activeName" @tab-click="handleClick" class="my-tab" stretch>
                        <el-tab-pane label="账号登录" name="first" class="login-div">
                            <el-form ref="form" :model="form" :rules="rules">
                                <el-form-item prop="username">
                                    <el-input
                                        placeholder="手机号/邮箱"
                                        v-model="form.username"
                                        class="first-input my-input"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item prop="password">
                                    <el-input
                                        placeholder="密码"
                                        v-model="form.password"
                                        class="second-input my-input"
                                        type="password"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item class="zcmm">
                                    <span
                                        style="color: #f64420;"
                                        @click="register()"
                                        class="fl shou"
                                    >立即注册</span>
                                    <span @click="forgetP()" class="fr shou">忘记密码?</span>
                                </el-form-item>
                                <p class="margin20">
                                    <el-checkbox class="login-form__tos" v-model="checked"></el-checkbox>
                                    <span class="tip">
                                        已阅读并同意
                                        <a href="#" @click="getUser()">《用户服务协议》</a>和
                                        <a href="#" @click="getYiSi()">《隐私策略》</a>
                                    </span>
                                </p>

                                <el-form-item>
                                    <button
                                        class="btn-center login-button"
                                        type="button"
                                        @click="submitFunc('form')"
                                    >医师登录</button>
                                </el-form-item>
                                <el-form-item>
                                    <el-row>
                                        <!-- <el-col :span="16">
                                            <div>
                                                其他登录方式：
                                                <img
                                                    src="../assets/logo/weixin.png"
                                                    alt
                                                    class="weixin"
                                                    @click="weixinLogin()"
                                                />
                                            </div>
                                        </el-col>-->
                                        <el-col :span="8" class="fr">
                                            <el-button
                                                size="mini"
                                                type="primary"
                                                class="btn-center"
                                                @click="LoginF()"
                                            >用户登录</el-button>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                                <!-- <el-form-item>
                                    <el-row>
                                        <el-col :span="16">
                                            <div>
                                                其他登录方式：
                                                <img
                                                    src="../assets/logo/weixin.png"
                                                    alt
                                                    class="weixin"
                                                    @click="weixinLogin()"
                                                />
                                            </div>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-button
                                                size="mini"
                                                type="primary"
                                                class="btn-center"
                                                @click="yhLoginF()"
                                            >用户登录</el-button>
                                        </el-col>
                                    </el-row>
                                </el-form-item>-->
                            </el-form>
                        </el-tab-pane>
                        <!-- <el-tab-pane label="手机验证" name="second" class="login-div">
                            <el-form ref="form1" :model="form1" :rules="rules1">
                                <el-form-item prop="phone">
                                    <el-input
                                        placeholder="手机号"
                                        v-model="form1.phone"
                                        class="first-input my-input"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item prop="yzm">
                                    <el-input placeholder="验证码" v-model="form1.yzm" class="yzm">
                                        <el-button
                                            slot="append"
                                            :disabled="disabledyzm"
                                            @click="getYZMF()"
                                        >{{btntxt}}</el-button>
                                    </el-input>
                                </el-form-item>
                                <el-form-item>
                                    <span
                                        style="color: #f64420;"
                                        @click="register()"
                                        class="fl"
                                    >立即注册</span>
                                </el-form-item>
                                <p class="margin20">
                                    <el-checkbox class="login-form__tos" v-model="checked1"></el-checkbox>
                                    <span class="tip">
                                        已阅读并同意
                                        <a href="#" @click="getUser()">《用户服务协议》</a>和
                                        <a href="#" @click="getYiSi()">《隐私策略》</a>
                                    </span>
                                </p>
                                <el-form-item>
                                    <button
                                        class="btn-center login-button"
                                        type="button"
                                        @click="submitFunc1('form1')"
                                    >医师登录</button>
                                </el-form-item>
                                <el-form-item>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>-->
                    </el-tabs>
                </div>
            </div>
        </div>
        <el-row>
            <el-col>
                <el-dialog
                    :title="title"
                    :visible.sync="centerDialogVisible"
                    width="60%"
                    center
                    class="mianUser"
                >
                    <span>{{content}}</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="centerDialogVisible = false">同 意</el-button>
                    </span>
                </el-dialog>
            </el-col>
        </el-row>
        <el-dialog :visible.sync="centerDialogVisible1" class="erweimaDialog" width="30%" center>
            <iframe :src="$store.state.imgUrl+erweimaUrl" frameborder="0" class="erweimaIframe"></iframe>
        </el-dialog>
    </div>
</template>

<script>
import rules from "@/common/rules";

export default {
    name: "ysLogin",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                if (this.formR.spassword !== "") {
                    // this.$refs.user.validateField("checkPass");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.formR.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            // 账号登陆验证
            rules: {
                password: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: "blur"
                    }
                ],
                username: [
                    {
                        required: true,
                        message: "请输入手机号或邮箱",
                        trigger: "blur"
                    }
                ]
            },
            // 短信登陆验证
            // rules1: {
            //     yzm: [
            //         {
            //             required: true,
            //             message: "请输入验证码",
            //             trigger: "blur"
            //         }
            //     ],
            //     phone: [
            //         {
            //             required: true,
            //             message: "请输入手机号",
            //             trigger: "blur"
            //         },
            //         {
            //             validator: rules.FormValidate.Form().validatePhone,
            //             trigger: ["blur", "change"]
            //         }
            //     ]
            // },
            activeName: "first",
            // 账号登陆表单
            form: {
                username: "",
                password: ""
            },
            // 短信登陆表单
            // form1: {
            //     phone: "",
            //     yzm: ""
            // },
            // rules2: {
            // password: [{ validator: validatePass, trigger: "blur" }],
            // spassword: [{ validator: validatePass2, trigger: "blur" }]

            // username: [
            //     {
            //         validator: rules.FormValidate.Form().validatePhone,

            //         trigger: ["blur", "change"]
            //     }
            // ]
            // },
            activeName: "first",
            formR: {
                username: "",
                password: "",
                spassword: ""
            },
            isLogin: true,
            setMarginTop: false,
            btntxt: "获取验证码",
            disabledyzm: false,
            time: 60,
            checked: true,
            checked1: true,
            centerDialogVisible: false,
            title: "",
            content: "",
            centerDialogVisible1: false,
            erweimaUrl: ""
        };
    },
    methods: {
        LoginF() {
            this.$router.replace({
                path: "/login"
            });
        },
        handleClick(tab, event) {},
        //忘记密码
        forgetP() {
            this.$router.push({ path: "/forgetP" });
        },
        // 注册
        register() {
            this.$router.push({ path: "/ysRegister" });
        },
        // 账号登陆
        submitFunc(form) {
            let that = this;
            that.$refs[form].validate(valid => {
                if (valid) {
                    let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                    let emailReg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
                    if (
                        phoneReg.test(that.form.username) ||
                        emailReg.test(that.form.username)
                    ) {
                    } else {
                        that.$message.error("请输入正确的手机或邮箱");
                        return false;
                    }
                    if (!this.checked) {
                        that.$message({
                            type: "warning",
                            message: "请阅读《用户服务协议》和《隐私策略》"
                        });
                        return false;
                    }
                    let url = "/user/login";
                    let params = {
                        temp: that.form.username,
                        password: that.form.password,
                        ys: true
                    };
                    that.$http
                        .post(url, params)
                        .then(res => {
                            if (res.data.code == 200) {
                                let arr = res.data.data;
                                sessionStorage.clear();
                                sessionStorage.setItem("YS", true);
                                sessionStorage.setItem(
                                    "userInfo",
                                    JSON.stringify(arr)
                                );
                                this.$router.replace({
                                    path: "/personalFiles"
                                });
                            } else {
                                if (res.data.code == 20000) {
                                    that.$message.error(res.data.msg);
                                } else {
                                    that.$message.error(res.data.data);
                                }
                            }
                        })
                        .catch(() => {
                            that.$message.error("网络错误！");
                        });
                }
            });
        }
        // 手机验证登陆
        // submitFunc1(form1) {
        //     let that = this;
        //     that.$refs[form1].validate(valid => {
        //         if (valid) {
        //               if (!this.checked1) {
        //                 that.$message({
        //                     type: "warning",
        //                     message: "请阅读《用户服务协议》和《隐私策略》"
        //                 });
        //                 return false;
        //             }
        //             let url = "/user/loginBySmsCode";
        //             let params = {
        //                 phone: that.form1.phone,
        //                 temp: that.form1.yzm,
        //                 ys:true,
        //             };
        //             that.$http
        //                 .post(url, params)
        //                 .then(res => {
        //                     if (res.data.code == 200) {
        //                         let arr = res.data.data;
        //                         sessionStorage.clear();
        //                         sessionStorage.setItem(
        //                             "userInfo",
        //                             JSON.stringify(arr)
        //                         );
        //                         sessionStorage.setItem("YS", true);
        //                         this.$router.push({
        //                             path: "/personalFiles"
        //                         });
        //                     } else {
        //                         that.$message.error(res.data.msg);
        //                     }
        //                 })
        //                 .catch(() => {
        //                     that.$message.error("网络错误！");
        //                 });
        //         }
        //     });
        // },
        // 获取验证码
        // getYZMF() {
        //     let that = this;
        //     if (!that.form1.phone) {
        //         that.$message.error("请先输入手机号");
        //         return false;
        //     }
        //     let url = "/sms/sendMessageToLogin";
        //     let params = {
        //         phone: that.form1.phone
        //     };
        //     that.$http
        //         .post(url, params)
        //         .then(res => {
        //             if (res.data.code == 200) {
        //                 that.$message({
        //                     message: "验证码发送成功",
        //                     type: "success"
        //                 });
        //                 that.disabledyzm = true;
        //                 that.timeryzm();
        //             } else {
        //                 that.$message.error(res.data.msg);
        //             }
        //         })
        //         .catch(() => {
        //             that.$message("网络错误！");
        //         });
        // },

        // yhLoginF() {
        //     this.$router.push({
        //         path: "/login"
        //     });
        // },
        // 微信登陆
        // weixinLogin() {
        //     let that = this;
        //     let url = "wxLogin/qrconnect";
        //     that.$http
        //         .post(url)
        //         .then(res => {
        //             if (res.data.code == 200) {
        //                 // localStorage.setItem("wxIsYs", "1");
        //                 sessionStorage.setItem("YS",true)
        //                 // window.location.href = res.data.data;
        //                 that.centerDialogVisible1 = true;
        //                 that.erweimaUrl = res.data.data;
        //             } else {
        //                 that.$message.error(res.data.msg);
        //             }
        //         })
        //         .catch(() => {
        //             that.$message.error("网络错误！");
        //         });
        // }
    }
};
</script>

<style scoped>
.set-margin {
    margin-top: 20px;
}
.two {
    font-size: 14px;
    padding-bottom: 20px;
    cursor: pointer;
}
.ysLogin {
    background: url(../assets/logo/bg.jpg) no-repeat center center;
}
.outer {
    padding: 50px 0px;
    height: 415px;
    /* background: url(../assets/logo/outer.png) no-repeat center center; */
    position: relative;
    margin: 0 auto;
}

.inner {
    position: absolute;
    top: 30px;
    right: 4%;
    width: 290px;
}
.login-button {
    width: 100%;
    height: 46px;
    background-color: #f64320;
    border-radius: 2px;
    color: #fff;
    border: 1px solid #f64320;
}
.login-button:focus {
    border: 1px solid #f64320 !important;
}
.weixin {
    display: inline-block;
    vertical-align: middle;
}
.refresh-icon {
    background-color: #fff !important;
}
/* .inner1 {
    top: 65px;
} */
.img-div-outer {
    width: 814px;
    margin: 0 auto;
    position: relative;
}
.tip {
    font-size: 12px;
}
.zcmm {
    margin-bottom: 0px;
}
</style>
<style>
.erweimaDialog .el-dialog--center .el-dialog__body {
    text-align: center;
    height: 400px;
}
.erweimaIframe {
    height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/ysLogin.vue